<template>
 <div class="tz-box">
    <p class="tz-animate">
        {{content}}
    </p>
</div>
</template>
<script>
export default {
   props:{
       content:{
           type: String,
           default: ''
       }
   }
}
</script>
<style scoped>
.tz-box {
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    line-height: 0;
}
.tz-animate {
    width: 100%;
    width: 5.3rem;
    margin:0;
    padding:0;
    display: inline-block;
    white-space: nowrap;
    line-height: 1;
    animation: 5s wordsLoop linear infinite normal;

}
@keyframes wordsLoop {

    0% {

        transform: translateX(100%);

        -webkit-transform: translateX(100%);

    }

    100% {

        transform: translateX(-100%);

        -webkit-transform: translateX(-100%);

    }

}

@-webkit-keyframes wordsLoop {

    0% {

        transform: translateX(100%);

        -webkit-transform: translateX(100%);

    }

    100% {

        transform: translateX(-100%);

        -webkit-transform: translateX(-100%);

    }

}
</style>


// WEBPACK FOOTER //
// src/components/paomadeng2.vue